import { computed } from 'vue';
import Paper from '../paper/component-lib.esm.js';
import { PaperProps } from '../paper/component-lib.esm2.js';
import { useTheme } from '../../compositions/component-lib.esm3.js';
import { getTextColor } from '../../styles/theme/component-lib.esm.js';

//
var script = {
  name: 'Toolbar',
  components: {
    Paper
  },
  props: {
    ...PaperProps,
    rounded: Boolean,
    flat: Boolean,
    dense: Boolean
  },
  setup(props) {
    const theme = useTheme();
    const classes = computed(() => {
      return {
        'v-toolbar--rounded': props.rounded,
        'v-toolbar--flat': props.flat,
        'v-toolbar--dense': props.dense
      };
    });
    const textColor = computed(() => {
      return getTextColor(props.color, theme.value);
    });
    const styles = computed(() => {
      return {
        '--c-text-color': textColor.value
      };
    });
    return {
      classes,
      styles,
      textColor
    };
  }
};
export { script as default };